if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          updateCartForThreshold();
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });


    const productId = document.querySelector("body").getAttribute("free_pro_id"); // Product ID to add/remove
    const threshold = 5000; // Threshold in cents (Shopify stores prices in cents)
    let freeProductAdded = false; // Track if the free product has already been added

    function updateCartForThreshold() {
        fetch('/cart.js', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to fetch cart data');
                }
                return response.json();
            })
            .then((cart) => {
                const cartTotal = cart.items_subtotal_price; // Total price in cents
                const productInCart = cart.items.find((item) => item.id === Number(productId));

                if (cartTotal >= threshold) {
                    // Add product only if it hasn't been added yet
                    if (!freeProductAdded && (!productInCart || productInCart.quantity !== 1)) {
                        addProductToCart(productId, 1);
                        freeProductAdded = true; // Mark as added
                    }
                } else {
                    // Remove the product if total is below the threshold
                    if (productInCart) {
                        removeProductFromCart(productId);
                        freeProductAdded = false; // Reset the flag
                    }
                }
            })
            .catch((error) => {
                console.error('Error handling cart:', error);
            });
    }

    function addProductToCart(productId, quantity) {
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: productId,
                quantity: quantity,
            }),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to add product to cart');
                }
                return response.json();
            })
            .then((data) => {
                console.log('Product added to cart:', data);
            })
            .catch((error) => {
                console.error('Error adding product to cart:', error);
            });
    }

    function removeProductFromCart(productId) {
        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: productId,
                quantity: 0, // Set quantity to 0 to remove product
            }),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to remove product from cart');
                }
                return response.json();
            })
            .then((data) => {
                console.log('Product removed from cart:', data);
            })
            .catch((error) => {
                console.error('Error removing product from cart:', error);
            });
    }

    // Initial check on page load
    updateCartForThreshold();
}
